// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DataCache } from '../../DataCache';
import { AccountType } from '@shared/utils/cache/Accounts/Account.types';
import { TvAccountTableManager } from './TvAccountTableManager';
import { TvAccountHelper } from '../Helpers/TvAccountHelper';
export class TvAccountsManager {
    constructor(host) {
        this.accountTableManager = new TvAccountTableManager(host);
        this.updateAccountData();
    }
    getSummary() {
        return this.accountTableManager.getSummary();
    }
    getPages() {
        return this.accountTableManager.getPages();
    }
    getCustomFormatters() {
        return this.accountTableManager.getCustomFormatters();
    }
    accountsMetainfo() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, reject) => {
                const accounts = DataCache.Accounts;
                const items = [];
                for (const accID in accounts) {
                    const account = accounts[accID];
                    if (account.AccountType === AccountType.MultiAsset) {
                        continue;
                    }
                    const item = {
                        id: account.BstrAccount,
                        name: account.FullAccString
                    };
                    const asset = account.assetBalanceDefault ? account.assetBalanceDefault.Asset : null;
                    if (asset) {
                        item.currency = asset ? asset.Name : '';
                    }
                    items.push(item);
                }
                if (items.length === 0) {
                    const item = {
                        id: TvAccountHelper.getFakeAccountId(),
                        name: 'You can use only Single Currency account type. Please, contact your broker for more information.'
                    };
                    items.push(item);
                }
                items.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
                resolve(items);
            });
        });
    }
    changeAccount() {
        this.updateAccountData();
    }
    subscribeEquity() {
        this.accountTableManager.subscribeEquity();
    }
    unsubscribeEquity() {
        this.accountTableManager.unsubscribeEquity();
    }
    subscribeMarginAvailable(symbol) {
        this.accountTableManager.subscribeMarginAvailable(symbol);
    }
    unsubscribeMarginAvailable(symbol) {
        this.accountTableManager.unsubscribeMarginAvailable(symbol);
    }
    static getDefaultAccount() {
        let curAccount = DataCache.MainAccountNew;
        if (curAccount.AccountType === AccountType.SingleCCY) {
            return curAccount;
        }
        curAccount = curAccount.User.Accounts.find((acc) => acc.AccountType === AccountType.SingleCCY);
        if (!isNullOrUndefined(curAccount)) {
            return curAccount;
        }
        const accounts = DataCache.Accounts;
        for (const accID in accounts) {
            const account = accounts[accID];
            if (account.AccountType === AccountType.SingleCCY) {
                return account;
            }
        }
        return null;
    }
    updateAccountData() {
        const account = TvAccountHelper.getCurrentAccount();
        if (isNullOrUndefined(account))
            return;
        this.accountTableManager.updateTable();
    }
}
